import {useTranslation} from 'react-i18next'
import ConverterDropZone from '../converterShared/ConverterDropZone'
import {useConverterVideoUpload} from './useConverterVideoUpload'
import type {LoadedVideo} from './loadConverterVideoFile'
import {VIDEO_INPUT_ACCEPT} from '../../../common/constants/videoToGifLimits'

interface VideoSourceUploadProps {
  video: LoadedVideo | null
  onVideoLoaded: (video: LoadedVideo) => void
  onClear: () => void
}

// The filmstrip preview (VideoTrimFilmstrip.tsx) is the real video preview —
// this panel is just the pick/replace/clear entry point, matching how
// ImageSourceUpload stays a thin thumbnail next to ImagePreviewCanvas's
// bigger interactive preview.
const VideoSourceUpload = ({video, onVideoLoaded, onClear}: VideoSourceUploadProps) => {
  const {t} = useTranslation()
  const {busy, error, handleFileSelected} = useConverterVideoUpload(onVideoLoaded)

  return (
    <ConverterDropZone
      accept={VIDEO_INPUT_ACCEPT}
      busy={busy}
      hasFile={video !== null}
      pickLabel={t('videoToGif.upload.pick')}
      replaceLabel={t('videoToGif.upload.replace')}
      clearLabel={t('videoToGif.upload.clear')}
      busyLabel={t('videoToGif.upload.busy')}
      hint={t('videoToGif.upload.hint')}
      error={error}
      onFileSelected={handleFileSelected}
      onClear={onClear}
    >
      {video && (
        <p className="cvt-hint">
          {t('videoToGif.upload.loadedInfo', {
            duration: video.duration.toFixed(1),
            width: video.width,
            height: video.height,
          })}
        </p>
      )}
    </ConverterDropZone>
  )
}

export default VideoSourceUpload
